import { colors } from '../../Colors/colors'

export const displayStages = {
   light: {
      common: {
         defaultTextColor: colors['gray-900'],
         baseBgColor: 'bg-white',
         borderColor: 'border-gray-300',
         checkPointCountColor: 'text-gray-700',
         separatorBgColor: 'bg-gray-200'
      },
      allowedGoFs: {
         pickerTickIconColor: colors['primary-600'],
         customOptionHoverBgColor: 'hover:bg-gray-50',
         selectedGoFOptionBgColor: 'bg-gray-50',
         notSelectedGofOptionBgColor: 'bg-white',
         customOptionTextColor: 'text-gray-700'
      },
      transitionCheckpoints: {
         checkpointsCountColor: 'text-gray-600',
         checkpointsCountTextColor: 'text-gray-500',
         seperatorBgColor: 'bg-gray-200'
      }
   },
   dark: {}
}
